import React from 'react';

export interface IColumnSettingsPayload {
  tableId: string;
  columns: string[];
}
export interface IPropsContext {
  columns: IColumnSettingsPayload[];
  setColumnsSetting: React.Dispatch<
    React.SetStateAction<IColumnSettingsPayload[]>
  >;
}

export const TABLE_COLUMNS = [
  {
    label: 'Display Id',
    value: 'displayId',
  },
  {
    label: 'Name',
    value: 'name',
  },
  { label: 'Channel', value: 'channel' },
  { label: 'Project Code', value: 'projectCode' },
  { label: 'Clinic Code', value: 'clinicCode' },
  { label: 'Amili PIC', value: 'amiliPIC' },
];
export const ColumnsSettingContext = React.createContext<IPropsContext>({
  columns: [],
  setColumnsSetting: () => {},
});
